
import axios from "axios";
import { store } from "store";
import { OutputBaseProps, PaginationProps } from "utils/types/API";
import { ServiceItemProps } from ".";
import { loading, index, options } from "store/service";

interface ApiServiceInputProps {
    page?: number;
    pageSize?: number;
    q?: string;
}

type ApiServiceOutputProps = OutputBaseProps<{ list: ServiceItemProps[]; pagination?: PaginationProps; }>

export const apiServiceIndex = async (data: ApiServiceInputProps) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiServiceOutputProps>("/api/services", { params: data }))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(index({ data: res.data.list, pagination: res.data.pagination }));
    }
    return res;
};

export const apiServiceOptions = async (data: { q?: string; }) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiServiceOutputProps>("/api/services", { params: { ...data } }))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(options({ data: res.data.list }));
    }
    return res;
};